<ng-container *ngIf="element.type === 'org-logo'">
  <ng-container *ngIf="orgLogoLoaded; else placeholderImage">
    <div class="org-logo-img-wrapper">
      <img
        class="org-logo-img"
        [style.width.%]="100"
        [style.height.%]="100"
        [style.object-fit]="element.fit ?? 'contain'"
        [src]="getOrgLogo()"
        alt="Organization Logo"
      />
    </div>
  </ng-container>

  <ng-template #placeholderImage>
    <div
      style="
        width: 98%;
        height: 98%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f9fafb;
        border: 1px dashed #d1d5db;
      "
      class="exclude-from-pdf"
    >
      <div style="text-align: center; color: #6b7280">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="#9CA3AF" style="margin-bottom: 2px">
          <path
            d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
          />
        </svg>
        <div style="font-size: 12px; margin-top: 2px">Loading...</div>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="element.type === 'image'">
  <ng-container *ngIf="isImageHidden; else visibleImage">
    <div
      (click)="onReplaceableImageClick()"
      style="
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fafafa;
        cursor: pointer;
      "
      class="exclude-from-pdf"
    >
      <div style="text-align: center; color: #9ca3af">
        <mat-icon style="font-size: 48px; width: 48px; height: 48px">visibility_off</mat-icon>
        <div style="font-size: 12px; margin-top: 4px">Image hidden — click to change</div>
      </div>
    </div>
  </ng-container>

  <ng-template #visibleImage>
    <ng-container *ngIf="needsImageReplacement; else resolvedImage">
      <div
        (click)="onReplaceableImageClick()"
        style="
          width: 98%;
          height: 98%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f0f9ff;
          border: 2px dashed #60a5fa;
          cursor: pointer;
        "
        class="exclude-from-pdf"
      >
        <div style="text-align: center; color: #3b82f6">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="#60a5fa" style="margin-bottom: 4px">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          </svg>
          <div style="font-size: 12px; margin-top: 2px">Click to add image</div>
        </div>
      </div>
    </ng-container>

    <ng-template #resolvedImage>
      <ng-container *ngIf="imageLoaded; else placeholderImageLoading">
        <div *ngIf="canReplaceImage; else staticImage" class="overlay-wrapper">
          <div *ngIf="imageSrc; else placeholderImageLoading" class="overlay-content-wrapper">
            <img
              class="org-logo-img"
              [style.width.%]="100"
              [style.height.%]="100"
              [style.object-fit]="element.fit ?? 'contain'"
              [src]="imageSrc"
              [alt]="element.slug || 'Image'"
            />
          </div>

          <div class="edit-overlay">
            <button
              mat-icon-button
              class="overlay-edit-button"
              title="Replace Image"
              (click)="onReplaceableImageClick()"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </div>

        <ng-template #staticImage>
          <img
            [style.width.%]="100"
            [style.height.%]="100"
            [style.object-fit]="element.fit ?? 'contain'"
            [src]="imageSrc"
            [alt]="element.slug || 'Image'"
          />
        </ng-template>
      </ng-container>
      <ng-template #placeholderImageLoading>
        <div
          style="
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f9fafb;
            border: 1px dashed #d1d5db;
          "
          class="exclude-from-pdf"
        >
          <div style="text-align: center; color: #6b7280">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="#9CA3AF" style="margin-bottom: 2px">
              <path
                d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
              />
            </svg>
            <div style="font-size: 12px; margin-top: 2px">Loading...</div>
          </div>
        </div>
      </ng-template>
    </ng-template>
  </ng-template>
</ng-container>
